<template>
    <tr v-if="columnGroup">
        <th class="premiere-colonne" :class="firstColClass"></th>
        <th :colspan="span" class="matrix__col--group-title autres-colonnes">
            <span v-once v-html="columnGroup"></span>
            <span v-once v-html="columnGroup" class="premiere-colonne--runin"></span>
        </th>
    </tr>
</template>

<script>

export default {
    name: 'matrix-column-group',

    props: {
        span: Number,
        columnGroup: [String, Array],
        firstColClass: String,
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-column-group.vue